import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["submitText", "submitSpinner"];

  submitted(event) {
    this.submitTextTarget.classList.add("hidden");
    this.submitSpinnerTarget.classList.remove("hidden");
  }
}
